import React from "react";
import ContactSection from "./../components/ContactSection";
import AllPageHead from "./../components/AllPageHead";

function ContactPage(props) {
  return (
    <div>
    <AllPageHead />
    <ContactSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Contact Us"
      subtitle=""
      buttonText="Send message"
      buttonColor="primary"
      showNameField={true}
      inputSize="md"
    ></ContactSection>
    </div>
  );
}

export default ContactPage;
